import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Checkbox, TextField, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//iconos
import { Add, Assignment, Close, OpenInBrowser, Visibility } from '@material-ui/icons';

//modal
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

//servicios
import { wsGetAll, wsCreate, wsPost } from 'services/WService.js';
import { Link } from 'react-router-dom';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import { wsFindBy } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  pills: {
    color: 'white',
    padding: '5px 8px 5px 8px',
    borderRadius: '10px',
    cursor: 'pointer'
  },
  icon: {
    fontSize: '20px',
    cursor: 'pointer',
    marginLeft: '5px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'DNI', accessor: 'codusu', width: 130 },
  { Header: 'Usuario', accessor: 'login', width: 100 },
  { Header: 'nombre', accessor: 'nombre' },
  {
    Header: 'HR pend.',
    accessor: 'hojasPendientes',
    excelEnabled: false,
    width: 130,
    align: 'center'
  },
  { Header: '# HR', accessor: 'hojas', excelEnabled: false, width: 100, align: 'center' },
  {
    Header: 'HR disp.',
    accessor: 'hojasDisponibles',
    excelEnabled: false,
    width: 120,
    align: 'center'
  },
  { Header: 'Zona', accessor: 'zone_description', width: 100 },
  { Header: 'IMEI', accessor: 'imei', width: 120 },
  { Header: 'Celular', accessor: 'phone', width: 100 },
  { Header: 'Estado', accessor: 'estado_jornada', width: 100 },
  { Header: 'Hora Jornada', accessor: 'hora_apertura', width: 150 },
  { Header: 'Inicio Operación', accessor: 'start_operation_at', width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function CancelLiquidation(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [boss, setBoss] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [base_zone_id, setZones] = useState([]);
  const [selectedZones, setSelectedZones] = useState([]);
  const [selectedBoss, setSelectedBoss] = useState(null);

  async function listBoss() {
    setDataLoading(true);
    let data = {};
    if (selectedZones.length > 0) {
      data.base_zone_id = selectedZones.map((zone) => zone.id);
    }
    let response = await wsFindBy('deliv/jefe-reparto', data);
    setDataLoading(false);
    if (response.success) setBoss(response.data);
  }

  async function listZones() {
    setDataLoading(true);
    let res = await wsGetAll('base/zone');
    setDataLoading(false);
    if (res.success) {
      setZones(res.data);
      setSelectedZones(res.data);
    }
  }

  useEffect(() => {
    listZones();
  }, []);

  useEffect(() => {
    if (selectedZones.length > 0) {
      listBoss();
    }
  }, [selectedZones]);

  return (
    <>
      <Toasty action={notify} />
      <Card>
        <CardHeader icon>
          <CardIcon pointer="true" color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Cancelar Liquidación de Jornadas {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
              <MultiComplete
                label="Zonas"
                selectAll
                limitTags={1}
                textField="description"
                options={base_zone_id}
                disabled={dataLoading}
                selected={selectedZones}
                setSelected={setSelectedZones}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Autocomplete
                options={boss}
                getOptionLabel={(item) => `${item.nombre} (${item.id})`}
                renderInput={(params) => (
                  <TextField {...params} label="Jefe de Reparto" margin="normal" fullWidth />
                )}
                onChange={(e, item) => setSelectedBoss(item)}
                value={selectedBoss}
              />
            </GridItem>
          </GridContainer>
          
          <ReactTable
            excelName="Cancelar-Liquidacion"
            defaultWidth={1300}
            columns={columns}
            data={(selectedBoss ? boss.filter((b) => b.id === selectedBoss.id) : boss).map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    {item.estado_jornada === 'C' ? (
                      <ReOpenClosingWorkday item={item} setDataLoading={setDataLoading} reload={listBoss} showNotify={showNotify} />
                    ) : undefined}
                  </div>
                ),
                codusu: item.codusu,
                login: item.login,
                nombre: item.nombre,
                hojasPendientes:
                  item.hojasPendientes.length == 0 ? undefined : (
                    <Tooltip title={item.hojasPendientes?.toString() || 'No tiene'} interactive>
                      <span className={classes.pills} style={{ background: '#ff003b' }}>
                        {item.hojasPendientes?.length || 0}
                      </span>
                    </Tooltip>
                  ),
                hojas: (
                  <Tooltip title={item.hojas?.toString() || 'No tiene'} interactive>
                    <span
                      className={classes.pills}
                      style={{ background: item.hojas.length > 0 ? '#17b70d' : 'orange' }}
                    >
                      {item.hojas?.length || 0}
                    </span>
                  </Tooltip>
                ),
                hojasDisponibles:
                  item.hojasDisponibles.length == 0 ? undefined : (
                    <Tooltip title={item.hojasDisponibles?.toString() || 'No tiene'} interactive>
                      <span className={classes.pills} style={{ background: '#00a1ff' }}>
                        {item.hojasDisponibles?.length || 0}
                      </span>
                    </Tooltip>
                  ),
                imei: item.imei,
                phone: item.phone,
                zone_description: item.zone_description || '-',
                hora_apertura: item.hora_apertura || '-',
                start_operation_at: item.start_operation_at || '-',
                estado_jornada:
                  item.estado_jornada === 'O'
                    ? 'Abierto'
                    : item.estado_jornada === null
                    ? 'Sin abrir'
                    : item.estado_jornada === 'C'
                    ? 'Cerrado'
                    : 'No definido',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});

const ReOpenClosingWorkday = ({ item, reload, setDataLoading, showNotify }) => {
  const classes = useStyles();

  const openWorkClosingdays = async () => {
    setDataLoading(true);
    const response = await wsPost(`deliv/jornada/${item.jornada_id}/revertir-cierre`, {
      codusu: item.codusu,
      hojas: item.hojas
    });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
      reload();
    }
  };

  return (
    <Tooltip title="Reabrir jornada liquidada">
      <OpenInBrowser onClick={openWorkClosingdays} className={classes.icon} style={{ color: '#c10000' }} />
    </Tooltip>
  );
};
